import visibility from '../../shared/javascripts/modules/visibility'

up.on(visibility.changeEvent, () => {
  up.emit(visibility.hidden() ? 'app:hidden' : 'app:visible')
})

up.on('click', '.input-group-addon', function() {
  let $element = $(this)

  if ($element.prev().is('input')) {
    $element.prev().focus()
  } else {
    $element.closest('.input-group').find('input:eq(0)').focus()
  }
})

up.compiler('input[type="number"]', (element) => {
  const $element = $(element)
  $element.on('wheel', function(event) {
    event.preventDefault()
  })
})
